import React, { useEffect, useState } from "react";
import { Content, Main } from "../../../components/Layout";
import TableResponsive from "../../../components/TableResponsive";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import Accordion from "../../../components/Accordion";
import styleAccordeon from "../../../components/Accordeon/style.module.css";

/**
 * Headcount de Convites/Ingressos por evento, pra turma inteira — só leitura,
 * puramente informativo (não é o que entra no financeiro contratado). Extra
 * já vem separado por origem direto do backend: Contratado (negociado pelo
 * gestor) e Loja Virtual (comprado e pago pelo formando).
 */
export default function Invites() {
  const { commercial } = useOutletContext();
  const { config, setbreadcrumb } = useWrapper();
  const [trainees, settrainees] = useState();

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial, setbreadcrumb]);

  useEffect(() => {
    (async () => {
      if (!commercial?.id) return;
      try {
        const { data } = await api.get(`commercial-event-invite/trainees?commercial_id=${commercial.id}`, config);
        settrainees(data);
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Problema ao carregar os Convites/Ingressos da turma.");
      }
    })();
  }, [commercial?.id, config]);

  const _events = [];
  const _seen = new Set();
  for (const __row of trainees || []) {
    if (_seen.has(__row.event_id)) continue;
    _seen.add(__row.event_id);
    _events.push({ id: __row.event_id, name: __row.event_name });
  }

  // Convite e Ingresso são coisas diferentes — cada combinação evento×tipo vira um item de
  // accordion próprio (ex: "Convites - Colação de Grau", "Ingressos - Colação de Grau"), em vez
  // de aninhar as duas tabelas dentro de um único item por evento. Combinação zerada (Base,
  // Contratado e Loja Virtual todos 0) nem aparece — não ajuda em nada numa lista pro dia do evento.
  const buildRows = (rows, prefix) => rows?.filter(__row => (__row[`qtd_${prefix}`] || 0) > 0) || [];
  const buildTable = (rows, prefix) => ({
    head: [
      { data: "Formando" },
      { data: "Base" },
      { data: "Contratado (Extra)" },
      { data: "Loja Virtual (Extra)" },
      { data: "Total" },
    ],
    body: rows.map(__row => ({
      link: `/trainees/invites/${__row.id}`,
      data: [
        { element: __row.name },
        { element: __row[`base_${prefix}`] },
        { element: __row[`extra_${prefix}_contratado`] },
        { element: __row[`extra_${prefix}_loja`] },
        { element: <b>{__row[`qtd_${prefix}`]}</b> },
      ],
    })),
  });

  const _sections = [];
  for (const __event of _events) {
    const _eventRows = trainees?.filter(__row => __row.event_id === __event.id);
    const _invitationRows = buildRows(_eventRows, "invitations");
    const _ticketRows = buildRows(_eventRows, "tickets");
    if (_invitationRows.length > 0) {
      _sections.push({
        key: `${__event.id}-invitations`,
        title: `Convites - ${__event.name}`,
        rows: _invitationRows,
        prefix: "invitations",
      });
    }
    if (_ticketRows.length > 0) {
      _sections.push({
        key: `${__event.id}-tickets`,
        title: `Ingressos - ${__event.name}`,
        rows: _ticketRows,
        prefix: "tickets",
      });
    }
  }

  return (
    <Main>
      {!commercial || !trainees ? (
        <Content>
          <Loading />
        </Content>
      ) : (
        <Content>
          <h2 className="form-title mb-1">Convites e Ingressos</h2>
          <p className="small-label mb-4">
            Quantos convites e ingressos cada formando vai levar, por evento: Base do pacote/avulso, Extra negociado
            com o gestor (já no Financeiro) e Extra comprado na Loja Virtual (fora do Financeiro).
          </p>
          {_sections.length === 0 && <p className="small-label">Nenhum evento com Convites/Ingressos configurados.</p>}
          {_sections.length > 0 && (
            <Accordion alwaysOpen>
              {_sections.map(__section => (
                <Accordion.Item key={__section.key} eventKey={__section.key}>
                  <Accordion.Header>
                    <p className={styleAccordeon.title} data-title="true">
                      {__section.title}
                    </p>
                  </Accordion.Header>
                  <Accordion.Body>
                    <TableResponsive table={buildTable(__section.rows, __section.prefix)} />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          )}
        </Content>
      )}
    </Main>
  );
}
